export const MENU = [
    { id: "top", active: true, text: "トップページ", path: "/#top" },
    { id: "about", active: false, text: "ペアラとは", path: "/#about" },
    { id: "more", active: false, text: "ペアラの機能", path: "/#more" },
    { id: "term", active: false, text: "利用規約", path: "/term" },
  ];

export const IS_COMPANY = 'isCompany'